import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const WefReducer = createSlice({
  name: "Wef",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("WefReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = WefReducer;
export const { defaultAction } = actions;
export default reducer;
